import React from 'react'
import {useParams} from "react-router-dom";

import './Picture.css'

function Picture(){

    const {picture} = useParams()

    console.log(picture)

    return(
        <img className='picture' src={`https://coasters.davidschnieders.de/backend/qr_codes/${picture}`}></img>
    )

}

export default Picture;
